module.exports = __webpack_public_path__ + "img/Puente_Istobal_MNEX32_Alto_Blanco-default-front.7ee4005d.jpg";